import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IWrbDetail, IWrbSearch } from "./wrbTypes";


class WrbService {
    async page(searchVo: IWrbSearch, config: object = {}) {
        const apiUrl = "/gtm/warning/payable";
        return await httpRequest.post<IPage<IWrbDetail>>(apiUrl, searchVo, config);
    }
    //导出
    async export(searchVo: IWrbSearch) {
        const appPageUrl = "/gtm/warning/payable/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
}

export const wrbService = new WrbService();
